exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--BQz2gWPJObNMnNCJgr6my {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: start;\n}\n\n.care-team-tasks--BQz2gWPJObNMnNCJgr6my.care-team-tasks--3DSOti3UaMB9rJJnvhxQxy {\n  color: #c9311a;\n}\n\n.care-team-tasks--BQz2gWPJObNMnNCJgr6my.care-team-tasks--3DSOti3UaMB9rJJnvhxQxy .care-team-tasks--2vZ15YssnQa6SUYpGVRlSv {\n  line-height: 0;\n  margin-left: 6px;\n}\n", ""]);

// exports
exports.locals = {
	"dueDate": "care-team-tasks--BQz2gWPJObNMnNCJgr6my",
	"dueDate": "care-team-tasks--BQz2gWPJObNMnNCJgr6my",
	"alert": "care-team-tasks--3DSOti3UaMB9rJJnvhxQxy",
	"alert": "care-team-tasks--3DSOti3UaMB9rJJnvhxQxy",
	"alertIcon": "care-team-tasks--2vZ15YssnQa6SUYpGVRlSv",
	"alertIcon": "care-team-tasks--2vZ15YssnQa6SUYpGVRlSv"
};